const API = "https://copypasteapi.cyclic.app";
export default API;
